import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Dayjs } from 'dayjs'
import { FieldArrayWithId, UseFieldArrayRemove, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { EmploymentFormValues } from '../../store/types/form/EmploymentFormValues'
import VacationPeriodEndDateInput from '../Form/EmploymentForm/inputs/VacationPeriodEndDateInput'
import VacationPeriodNumberOfDaysInput from '../Form/EmploymentForm/inputs/VacationPeriodNumberOfDaysInput'
import VacationPeriodOvertimeInput from '../Form/EmploymentForm/inputs/VacationPeriodOvertimeInput'
import VacationPeriodRemoveButton from './VacationPeriodRemoveButton'
import VacationPeriodStartDateInput from '../Form/EmploymentForm/inputs/VacationPeriodStartDateInput'
import React from 'react'

type Props = {
  vacationFields: FieldArrayWithId<EmploymentFormValues, 'vacationPeriods', 'id'>[]
  remove: UseFieldArrayRemove
  contractStart: Dayjs | null
  contractEnd: Dayjs | null
  renderVacationPeriodErrors: (index: number) => JSX.Element[] | null
}

const EmploymentFormVacationPeriodsDesktopView = ({
  vacationFields,
  remove,
  contractStart,
  contractEnd,
  renderVacationPeriodErrors,
}: Props) => {
  const { t } = useTranslation()
  const { formState } = useFormContext<EmploymentFormValues>()

  const hasVacationPeriodError = (index: number): boolean => {
    return !!formState.errors.vacationPeriods && !!formState.errors.vacationPeriods[index]
  }

  return (
    <TableContainer sx={{ border: 'none' }}>
      <Table size="small">
        <TableHead sx={{ '& .MuiTableCell': { color: 'text.highEmphasis' } }}>
          <TableRow>
            <TableCell>{t('page.employments.table.from')}</TableCell>
            <TableCell>{t('page.employments.table.to')}</TableCell>
            <TableCell>{t('page.employments.table.numberOfDays')}</TableCell>
            <TableCell>{t('page.employments.table.overtime')}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {vacationFields.length ? (
            vacationFields.map((field, index) => (
              <React.Fragment key={field.id}>
                <TableRow
                  sx={{ '& .MuiTableCell-root': { border: hasVacationPeriodError(index) ? 'none' : undefined } }}
                >
                  <TableCell>
                    <VacationPeriodStartDateInput
                      index={index}
                      contractStart={contractStart}
                      contractEnd={contractEnd}
                    />
                  </TableCell>
                  <TableCell>
                    <VacationPeriodEndDateInput index={index} contractStart={contractStart} contractEnd={contractEnd} />
                  </TableCell>
                  <TableCell>
                    <VacationPeriodNumberOfDaysInput index={index} />
                  </TableCell>
                  <TableCell>
                    <VacationPeriodOvertimeInput index={index} />
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      height: '100%',
                    }}
                  >
                    <Stack direction="row" alignItems="center">
                      <Stack width="25%" justifyContent="center" alignItems="center">
                        <VacationPeriodRemoveButton index={index} onRemove={remove} />
                      </Stack>
                    </Stack>
                  </TableCell>
                </TableRow>
                {hasVacationPeriodError(index) && (
                  <TableRow>
                    <TableCell sx={{ pb: 1 }} colSpan={5}>
                      {renderVacationPeriodErrors(index)}
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))
          ) : (
            <TableRow style={{ height: 32 }}>
              <TableCell colSpan={5} align="center"></TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default EmploymentFormVacationPeriodsDesktopView
